import React, { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

export default function InstallButton({ className = "" }) {
  const [deferred, setDeferred] = useState(null);
  const [showIosHelp, setShowIosHelp] = useState(false);

  const isStandalone = typeof window !== "undefined" &&
    (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone);
  const isIos = typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (isStandalone) return null;
  // Show only when installable (Android/desktop) or on iOS (manual instructions)
  if (!deferred && !isIos) return null;

  const onClick = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
    } else if (isIos) {
      setShowIosHelp(true);
    }
  };

  return (
    <>
      <button onClick={onClick} data-testid="install-app-btn" className={className || "w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-[#E6B34A] text-[#0A1030] text-sm font-bold hover:bg-[#CF9A34] transition-colors"}>
        <Download className="w-4 h-4" /> Install app
      </button>

      {showIosHelp && (
        <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center p-4" data-testid="ios-install-help">
          <div className="absolute inset-0 bg-[#050818]/80 backdrop-blur-sm" onClick={() => setShowIosHelp(false)} />
          <div className="relative w-full max-w-sm rounded-3xl border border-[#E6B34A]/20 bg-[#141C42] p-6">
            <button onClick={() => setShowIosHelp(false)} className="absolute top-4 right-4 text-zinc-500 hover:text-white"><X className="w-4 h-4" /></button>
            <Download className="w-8 h-8 text-[#E6B34A] mb-3" />
            <h3 className="font-display font-bold text-lg tracking-tight">Add to Home Screen</h3>
            <p className="text-sm text-zinc-300 mt-3 leading-relaxed">
              To install In His Image Radio on your iPhone or iPad:
            </p>
            <ol className="text-sm text-zinc-300 mt-3 space-y-2 list-decimal list-inside">
              <li>Tap the <Share className="inline w-4 h-4 text-[#E6B34A]" /> <b>Share</b> button in Safari</li>
              <li>Scroll and tap <b>Add to Home Screen</b></li>
              <li>Tap <b>Add</b> — you're all set! 🙌</li>
            </ol>
          </div>
        </div>
      )}
    </>
  );
}
